(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lovele-cart-reset"] && !Shopify.designMode) return;
  try {
    (() => {
    const markerName = "lovele_yampi_order_created";
    const reloadKey = "lovele_cart_reset_reload";
    const hasMarker = document.cookie
      .split("; ")
      .some((cookie) => cookie.startsWith(`${markerName}=`));

    if (!hasMarker) {
      sessionStorage.removeItem(reloadKey);
      return;
    }

    const root = window.Shopify?.routes?.root || "/";

    fetch(`${root}cart/clear.js`, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: "{}"
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Cart reset failed");
        }

        document.cookie = `${markerName}=; Max-Age=0; Path=/; SameSite=Lax; Secure`;
        document.cookie = `${markerName}=; Max-Age=0; Path=/; Domain=.lovelecosmeticos.com; SameSite=Lax; Secure`;

        window.dispatchEvent(new CustomEvent("cart:refresh"));
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));

        if (sessionStorage.getItem(reloadKey) !== "1") {
          sessionStorage.setItem(reloadKey, "1");
          window.location.reload();
        }
      })
      .catch(() => {
        sessionStorage.removeItem(reloadKey);
      });
  })();
  } catch(e) { console.error(e); }
})();

})();
